import { connect } from 'react-redux';
import { State } from '~/Store';
import { switchBack } from '~/UserImpersonate';

import Panel from './Panel';

function mapStateToProps(state: State) {
	const { accessToken } = state.accessToken;
	return {
		user: accessToken?.user ?? null,
		impersonatedBy: accessToken?.impersonatedBy ?? null,
	};
}

const actions = {
	onSwitchBack: switchBack,
};

export default connect(mapStateToProps, actions)(Panel);
